import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';

import { catchError, map, switchMap } from 'rxjs/operators';
import { IEffect } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effect.interface';
import {
  LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS,
  PurchaseOrderMaskPatterLoadAction,
  PurchaseOrderMaskPatterLoadCompleteAction,
  PurchaseOrderMaskPatterLoadFailAction,
} from '../actions/jobsite-actions/jobsite.actions';
import { PurchaseOrderService, PurchaseOrderValidationRequestV8 } from '@cemex-core/cmx-api';
import { _safe } from '../../../../../modules/shared/utils/safe-get.method';
import { purchaseOrderMasksConvert } from '../../../../../modules/shared/utils/purchase-order-masks-convert';

@Injectable()
export class PurchaseOrderMaskModifyEffects implements IEffect {
  purchaseOrderMaskLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS),
      switchMap((action: PurchaseOrderMaskPatterLoadAction) => {
        const payload: PurchaseOrderValidationRequestV8 = {
          jobsiteId: action.payload.jobsiteId,
          productLine: action.payload.productLine,
        };
        return this.purchaseOrderService.getPOMasks(payload).pipe(
          map((data) => {
            const POMaskPatternsdata = _safe(() => data.formats.map((POMaskPattern) => POMaskPattern.format));
            return new PurchaseOrderMaskPatterLoadCompleteAction({
              purchaseOrderMaskPatterns: purchaseOrderMasksConvert(POMaskPatternsdata),
            });
          }),
          catchError((error) => of(new PurchaseOrderMaskPatterLoadFailAction())),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private purchaseOrderService: PurchaseOrderService,
  ) {}
}
